import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/**
 * /impersonate?token=...&role=...
 * Single-use bridge: the parent admin tab opens this in a new tab so the
 * impersonation session is installed in the NEW tab while the admin tab stays admin.
 */
export default function ImpersonateBridge() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const role = params.get('role') || 'student';
    const userJson = params.get('user');
    if (!token) {
      navigate('/login');
      return;
    }
    localStorage.setItem('token', token);
    if (userJson) {
      try { localStorage.setItem('user', userJson); } catch {}
    }
    localStorage.setItem('impersonating', 'true');
    const dest = role === 'teacher' ? '/teacher/dashboard'
      : role === 'parent' ? '/parent/dashboard'
      : '/student/dashboard';
    navigate(dest, { replace: true });
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
      Switching session…
    </div>
  );
}
